import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="relative min-h-screen bg-[#060b1a] text-white font-sans overflow-hidden">

      {/* ===== Soft Modern Gradient ===== */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute w-[700px] h-[700px] bg-gradient-to-br from-cyan-500/20 via-blue-600/20 to-indigo-700/20 blur-[160px] rounded-full -top-40 -left-40"></div>
        <div className="absolute w-[600px] h-[600px] bg-gradient-to-tr from-blue-500/20 to-purple-700/20 blur-[140px] rounded-full bottom-0 right-0"></div>
      </div>

      {/* ===== NAVBAR ===== */}
      <nav className="sticky top-0 bg-[#060b1a]/70 backdrop-blur-xl border-b border-white/10 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
          <span className="text-lg font-semibold tracking-wide bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
            Matches Guru
          </span>

          <div className="hidden md:flex items-center gap-8 text-sm text-gray-300">
            <a href="#features" className="hover:text-cyan-400 transition">Features</a>
            <a href="#faq" className="hover:text-cyan-400 transition">FAQ</a>
          <a
  href="https://t.me/+DZqYd1cQD4VjMWI0"
  target="_blank"
  rel="noopener noreferrer"
  className="hover:text-cyan-400 transition"
>
  Telegram
</a>

<a
  href="https://www.tiktok.com/@derivguru?_r=1&_t=ZS-948jHjpbKho"
  target="_blank"
  rel="noopener noreferrer"
  className="hover:text-cyan-400 transition"
>
  TikTok
</a>
            <Link
              to="/login"
              className="bg-gradient-to-r from-cyan-500 to-blue-600 px-5 py-2 rounded-full text-sm font-medium hover:opacity-90 transition"
            >
              Access — $150
            </Link>
          </div>
        </div>
      </nav>

      {/* ===== HERO (Reduced Height) ===== */}
      <section className="pt-24 pb-16 px-6 text-center max-w-5xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold leading-tight">
          Trade With a  
          <span className="block bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
            Matches Guru
          </span>
        </h1>

        <p className="mt-5 text-base md:text-lg text-gray-300 max-w-2xl mx-auto">
          When the market whispers digits, the Guru listens.  
          Real-time AI that spots high-probability last-digit Matches before the crowd catches on.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-5">
          <Link
            to="/login"
            className="bg-gradient-to-r from-cyan-500 to-blue-600 px-8 py-3 rounded-full font-medium hover:opacity-90 transition"
          >
            Become a Matches Guru — $150
          </Link>

          <a
            href="#features"
            className="border border-cyan-500/40 px-8 py-3 rounded-full hover:bg-cyan-900/20 transition"
          >
            See the Wisdom
          </a>
        </div>
      </section>

      {/* ===== FEATURES ===== */}
      <section id="features" className="py-20 px-6 max-w-6xl mx-auto">
        <h2 className="text-3xl font-semibold text-center mb-14">
          Why Trade Like a Guru?
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          {[
            ["Tick-by-Tick Awareness", "Scans every volatility movement in real time."],
            ["Digit Probability Engine", "Reads imbalance patterns before they form breakouts."],
            ["Precision Match Alerts", "Clean entry windows. No noise. Just clarity."],
            ["Even/Odd Backup Mode", "Because even gurus diversify wisdom."],
            ["All Volatility Indices", "From V10 to V100 including 1s variants."],
            ["Secure & Private", "Official OAuth login. No password storage."],
          ].map(([title, desc], i) => (
            <div
              key={i}
              className="bg-white/5 backdrop-blur-xl p-7 rounded-2xl border border-white/10 hover:border-cyan-400/40 transition"
            >
              <h3 className="text-lg font-semibold text-cyan-400">{title}</h3>
              <p className="text-gray-300 mt-3 text-sm">{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ===== PRICING (Balanced Size) ===== */}
      <section className="py-20 px-6 text-center">
        <div className="max-w-md mx-auto bg-[#0e162f] p-10 rounded-3xl border border-cyan-500/30 shadow-xl">
          <h2 className="text-2xl font-semibold mb-4">
            Guru Access
          </h2>

          <p className="text-4xl font-bold text-cyan-400">
            $150
          </p>

          <p className="text-gray-400 mt-1 text-sm">
            One-time payment. Lifetime signals.
          </p>

          <ul className="mt-6 space-y-3 text-left text-gray-200 text-sm">
            <li>✓ AI Matches Signals</li>
            <li>✓ Even/Odd Strategy</li>
            <li>✓ All Volatility Indices</li>
            <li>✓ Community Access</li>
            <li>✓ Ongoing Updates</li>
          </ul>

          <Link
            to="/login"
            className="mt-8 block bg-gradient-to-r from-cyan-500 to-blue-600 py-3 rounded-full font-medium hover:opacity-90 transition"
          >
            Enter the Dojo
          </Link>
        </div>
      </section>

      {/* ===== FAQ ===== */}
      <section id="faq" className="py-20 px-6 max-w-4xl mx-auto">
        <h2 className="text-3xl font-semibold text-center mb-12">
          Guru Questions
        </h2>

        <div className="space-y-5">
          {[
            ["Is this guaranteed profit?", "No system guarantees wins. The Guru focuses on probability, not promises."],
            ["Which indices are supported?", "All major Deriv volatility indices including 1s variants."],
            ["Is this subscription based?", "No subscriptions. One-time $150 lifetime access."],
            ["Do I need experience?", "Basic Matches knowledge helps, but the signals are structured and clear."],
          ].map(([q, a], i) => (
            <details key={i} className="bg-[#0d152a] p-5 rounded-xl border border-white/10">
              <summary className="cursor-pointer font-medium text-cyan-400">{q}</summary>
              <p className="mt-3 text-gray-300 text-sm">{a}</p>
            </details>
          ))}
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className="py-10 text-center text-gray-500 text-sm border-t border-white/10">
        <p>© 2026 Matches Guru</p>
        <p className="mt-2">Trading involves risk. Even gurus manage risk wisely.</p>
      </footer>

    </div>
  );
}